var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='white' d='M0 0h900v600H0z'/%3e%3ccircle fill='%23bc002d' cx='450' cy='300' r='180'/%3e%3c/svg%3e";
  export default img;